// prettier-ignore
app.controller("ApartmentPriceController",
	["$scope", "$rootScope", "$http", "$timeout", "$location", "$window", "$filter", "AreaNaviService", function($scope, $rootScope, $http, $timeout, $location, $window, $filter, AreaNaviService) {
		$scope.Utils = window.Utils;
		$scope.agents = [];
		$scope.changed = false;
		$scope.initialized = false;
		$scope.loading = false;
		$scope.selectionsMade = false;
		$scope.h1Text = '';
		$scope.apartmentInfo = '';
		$scope.comparisonInfoText = '';
		$scope.infoTexts = '';
		$scope.showAreaDropdown = false;
		$scope.priceGraphTitle = '';
		$scope.houseTypes = [
			{
				name: 'Kaikki',
				value: 'all'
			},
			{
				name: 'Kerrostalo',
				value: 'kt'
			},
			{
				name: 'Rivitalo',
				value: 'rt'
			},
			{
				name: 'Omakotitalo',
				value: 'okt'
			}
		];
		$scope.addressSearch = {
			suggestions: [
				{
					type: "c",
					name: "Kaupunki",
					values: []
				},
				{
					type: "p",
					name: "Postinumero",
					values: []
				}
			],
			input: "",
			active: 0
		};
		$scope.searchQuery = {
			houseType: 'all',
			areaSelect: 'Helsinki',
			rooms: 'all',
			yearBuilt: '',
			floorArea: ''
		};
		$scope.url = {
			location: '',
			type: $scope.searchQuery.houseType,
			room: $scope.searchQuery.rooms,
			year: $scope.searchQuery.yearBuilt,
			m2: $scope.searchQuery.floorArea
		};

		$scope.slickBreakpoints = [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		];

		$scope.houses = [];

		/**
		 * Update
		 */
		$scope.update = function()
		{
			if ($scope.data) {
				// Set to data to help template to display these
				$scope.data.figureData = [];
				if ($scope.data.ashiLatest) {
					$scope.data.figureData = $scope.data.ashiLatest;
				} else if ($scope.data.ashiCountyLatest) {
					$scope.data.figureData = $scope.data.ashiCountyLatest;
				}
				// Current year data?
				$scope.data.figureCurrentYear = [];
				if ($scope.data.ashiCurrentYear) {
					$scope.data.figureCurrentYear = $scope.data.ashiCurrentYear;
				} else if ($scope.data.ashiCountyCurrentYear) {
					$scope.data.figureCurrentYear = $scope.data.ashiCountyCurrentYear;
				}
				// Title text
				if ($scope.data.name !== undefined) {
					$scope.h1Text = 'Asuntojen hinnat ' + $scope.data.name;
				}
				// Apartment info text
				var apartmentInfo = '';
				if ($scope.data.params.type) {
					if ($scope.data.params.type == 'kt') {
						apartmentInfo = 'Kerrostalo';
					} else if ($scope.data.params.type == 'okt') {
						apartmentInfo = 'Omakotitalo';
					} else if ($scope.data.params.type == 'rt') {
						apartmentInfo = 'Rivitalo';
					} else {
						apartmentInfo = 'Kaikki';
					}
				}
				if ($scope.data.params.typeName) {
					$scope.priceGraphTitle = $scope.data.params.typeName + ($scope.data.params.roomNameTypes ? ' ' + $scope.data.params.roomNameTypes : '') + ' alueella ' + ($scope.data.postalCode ? $scope.data.postalCode + ', ' : '') + ($scope.data.postalName ? $scope.data.postalName : $scope.data.name);
				} else if ($scope.data.params.roomName) {
					$scope.priceGraphTitle = $scope.data.params.roomName + ' alueella ' + ($scope.data.postalCode ? $scope.data.postalCode + ', ' : '') + ($scope.data.postalName ? $scope.data.postalName : $scope.data.name);
				}
				if ($scope.data.params.room && $scope.data.params.room != 'all') {
					apartmentInfo += ', ' + $scope.data.params.room.replace('plus', '+');
				}
				if ($scope.data.params.year) {
					apartmentInfo += ', ' + $scope.data.params.year;
				}
				if ($scope.data.params.m2) {
					apartmentInfo += ', ' + $scope.data.params.m2 + 'm<sup>2</sup>';
				}
				if ($scope.data.postalName) {
					apartmentInfo += ', ' + $scope.data.postalName;
				}
				$scope.apartmentInfo = apartmentInfo;
				// Comparison
				if ($scope.data.comparison !== undefined && $scope.data.comparison.info !== undefined) {
					for (var i in $scope.data.comparison.info) {
						if (!$scope.data.comparison.info.hasOwnProperty(i)) {
							continue;
						}
						$scope.comparisonInfoText += $scope.data.comparison.info[i] + '. ';
					}
				}
				// Hand build info, from front apartment-prices.twig
				var infoTexts = '';
				if ($scope.data.figureData.priceperm2) {
					infoTexts += 'Toteutuneiden asuntokauppatilastojen perusteella asuntosi keskineliöhinta viime vuonna olisi ollut ' + $scope.data.figureData.priceperm2 + ' €/m<sup>2</sup>.';
				}
				if ($scope.data.params.postalcode) {
					if ($scope.data.ashiLatest && $scope.data.ashiCountyLatest && $scope.data.ashiLatest.priceperm2 && $scope.data.ashiCountyLatest.priceperm2) {
						if ($scope.data.ashiLatest.priceperm2 > $scope.data.ashiCountyLatest.priceperm2) {
							infoTexts += ' ' + $scope.data.postalName + ' on neliöhinnoiltaan kunnan keskiarvoa kalliimpi.';
						} else {
							infoTexts += ' ' + $scope.data.postalName + ' on neliöhinnoiltaan kunnan keskiarvoa edullisempi.';
						}
					}
				}
				if ($scope.data.params.year && $scope.data.comparison && $scope.data.comparison.m2) {
					infoTexts += ' Asuntosi arvo on muuttunut vuodesta ' + $scope.data.params.year + ' laskennallisesti ' + $filter('currency')($scope.data.comparison.m2.percent, '', ' ', ',', 2) +'%.';
				}
				if ($scope.data.comparison.price && $scope.data.comparison.m2 && $scope.data.comparison.price.percent && $scope.data.comparison.m2.percent) {
					if ($scope.data.comparison.m2.percent > $scope.data.comparison.price.percent) {
						infoTexts += ' Samaan aikaan kuluttajahintojen nousu - eli inflaatio - on ollut tätä pienempi.';
					} else {
						infoTexts += ' Samaan aikaan kuluttajahintojen nousu - eli inflaatio - on ollut tätä suurempi.';
					}
				}
				var averageSales = 0;
				if ($scope.data.ashiAverages && $scope.data.ashiAverages.sales) {
					averageSales = $scope.data.ashiAverages.sales;
				} else if ($scope.data.ashiCountyAverages && $scope.data.ashiCountyAverages.sales) {
					averageSales = $scope.data.ashiCountyAverages.sales;
				}
				if ($scope.data.figureData.sales) {
					if ($scope.data.figureData.sales > averageSales) {
						infoTexts += ' Neliöhinnan arvioinnissa on hyvä huomioida, että alueella on tehty viime vuonna keskimääräistä enemmän kauppaa.';
					} else {
						infoTexts += ' Neliöhinnan arvioinnissa on hyvä huomioida, että alueella on tehty viime vuonna keskimääräistä vähemmän kauppaa.';
					}
				}
				if ($scope.data.params.m2) {
					if ($scope.data.paavo && $scope.data.paavo.flat_size) {
						if ($scope.data.params.m2 > $scope.data.paavo.flat_size) {
							infoTexts += ' Asuntosi neliömäärä on alueen keskiarvoa suurempi, mikä myös vaikuttaa asunnon todelliseen arvoon.';
						} else {
							infoTexts += ' Asuntosi neliömäärä on alueen keskiarvoa pienempi, mikä myös vaikuttaa asunnon todelliseen arvoon.';
						}
					}
				}
				if (infoTexts) {
					$scope.infoTexts = '"' + infoTexts + '"';
				}
				// Update external links
				AreaNaviService.setData($scope.data.county, $scope.data.urlCounty, $scope.data.agencyLink, $scope.data.livingLink, $scope.data.pricesLink, 'prices');
				// If wakeHistory is loaded, track history for county/postcode
				if (window.wakeHistory) {
					if ($scope.data.county) {
						window.wakeHistory.trackHistory('seller-county', $scope.data.county);
					}
					if ($scope.data.postalCode) {
						window.wakeHistory.trackHistory('seller-postcode', $scope.data.postalCode);
					}
				}
			}
		};

		$scope.GetSearchAreaText = function() {
			return $scope.searchQuery.areaSelect.length ? $scope.searchQuery.areaSelect : 'Kirjoita kaupunki tai postinumero';

		};

		$scope.getSelectedHouseType = function() {
			if (!$scope.houseTypes || !$scope.houseTypes.length) {
				return '';
			}
			for (var i = 0, max = $scope.houseTypes.length; i < max; i++) {
				if ($scope.houseTypes[i].value == $scope.searchQuery.houseType) {
					return $scope.houseTypes[i].name;
				}
			}
		};

		$scope.AddSearchAddress = function(address, event) {
			if(typeof(address) == 'undefined') {
				return false;
			}
			event.preventDefault();
			event.stopPropagation();

			$scope.searchQuery.areaSelect = address.id;
			$scope.addressSearch.input = '';

			if ($scope.addressSearch && $scope.addressSearch.suggestions && $scope.addressSearch.suggestions.length) {
				for (var i = 0; i < $scope.addressSearch.suggestions.length; i++) {
					$scope.addressSearch.suggestions[i].values.length = 0;
				}
			}

			$scope.addressSearch.active = -1;
			$scope.showAreaDropdown = false;
		};

		$scope.GetAddressSuggestions = function(text) {

			$http({
				method: 'GET',
				url: '/api/km/KMSite/priceAreas',
				params: {
					key: text,
					limit: 50
				}
			}).then(function(response, status, headers, config) {
				ParseAddressSuggestions(response.data.data);
				// todo: kun 0, antamallasi hakusanalla ei löytynyt kohteita
			}, function(data, status, headers, config) {
				console.log("error getting address suggestions:", data);
			});
		};

		$scope.HandleAreaDropdownKeyPress = function(event) {

			// Up
			if(event.which == 38) {
				$scope.addressSearch.active = $scope.addressSearch.active > 0 ? $scope.addressSearch.active - 1 : GetAddressSuggestionsCount() - 1;
			}
			// Down
			else if(event.which == 40) {
				$scope.addressSearch.active = $scope.addressSearch.active < GetAddressSuggestionsCount() - 1 ? $scope.addressSearch.active + 1 : 0;
			}
			// Enter
			else if(event.which == 13) {
				if($scope.addressSearch.input && $scope.addressSearch.input.length > 0) {
					$scope.AddSearchAddress(GetAddressByAssignedIndex($scope.addressSearch.active), event);
				}
			}
			// ESC
			else if(event.which == 27) {

			}
			else {
				$scope.addressSearch.active = 0;
			}
		};

		function GetAddressSuggestionsCount() {
			var count = 0;
			if ($scope.addressSearch && $scope.addressSearch.suggestions && $scope.addressSearch.suggestions.length) {
				for (var i = 0; i < $scope.addressSearch.suggestions.length; i++) {
					count += $scope.addressSearch.suggestions[i].values.length;
				}
			}
			return count;
		}

		function GetAddressByAssignedIndex(index) {
			if ($scope.addressSearch && $scope.addressSearch.suggestions && $scope.addressSearch.suggestions.length) {
				for (var i = 0; i < $scope.addressSearch.suggestions.length; i++) {
					var addressType = $scope.addressSearch.suggestions[i].type;
					var subAddrArray = $scope.addressSearch.suggestions[i].values;
					for (var j = 0; j < subAddrArray.length; j++) {
						if (subAddrArray[j].index == index) {
							return subAddrArray[j];
						}
					}
				}
			}
			return undefined;
		}

		function ParseAddressSuggestions(suggestions) {
			if ($scope.addressSearch && $scope.addressSearch.suggestions && $scope.addressSearch.suggestions.length) {
				for (var i = 0; i < $scope.addressSearch.suggestions.length; i++) {
					var addressType = $scope.addressSearch.suggestions[i].type;
					var addressTypeName = $scope.addressSearch.suggestions[i].name;

					$scope.addressSearch.suggestions[i].values.length = 0;

					for (var j = 0; j < suggestions.length; j++) {
						if (suggestions[j].t == addressType) {
							suggestions[j].index = j;
							suggestions[j].id = suggestions[j].id;
							suggestions[j].value = suggestions[j].name;
							$scope.addressSearch.suggestions[i].values.push(suggestions[j]);
						}
					}
				}
			}

			// Resetoidaan aktiivinen arvo aina kun on haettu uusi setti osoite-ehdotuksia.
			if(suggestions.length > 0) {
				$scope.addressSearch.active = 0;
			}
			else {
				$scope.addressSearch.active = -1;
			}
		}


		$scope.$watch('addressSearch.input', function(newVal) {
			if(newVal !== '') {
				$scope.GetAddressSuggestions(newVal);
			}
		});

		$scope.updateUrl = function() {
			var locationParts = $scope.searchQuery.areaSelect.split(',');
			$scope.url.room = !$scope.searchQuery.rooms ? 'all' : $scope.searchQuery.rooms;
			$scope.url.m2 = $scope.searchQuery.floorArea;
			$scope.url.year = (!$scope.searchQuery.yearBuilt) ? '0' : $scope.searchQuery.yearBuilt;
			$scope.url.type = $scope.searchQuery.houseType;
			$scope.url.location = (locationParts.length === 2) ? locationParts[1].trim() + '/' + locationParts[0].trim() : ((/[0-9]{5}/.test(locationParts[0])) ? '0/' + locationParts[0].trim() : locationParts[0].trim() + '/0');
		};

		/**
		 * Init
		 */
		$scope.init = function(type)
		{
			// Init type?
			type = type || 'initial';

			// Set values from data
			$scope.update();

			$scope.$watchCollection('searchQuery', function() {

				$scope.updateUrl();

				var apartmentIntoParts = [];

				if ($scope.houseTypes[$scope.searchQuery.houseType] !== undefined) {
					for (var i = 0, max = $scope.houseTypes.length; max < i; i++) {
						if ($scope.searchQuery.houseType === $scope.houseTypes[i].value) {
							apartmentIntoParts.push($scope.houseTypes[i].name);
						}
					}
				}

				$scope.selectionsMade = true;
			});

			if (!$scope.data) {
				// No data to draw
				return;
			}
			// Set values from URL
			if (/asuntojen-hinnat\/?$/.test($location.$$absUrl) === false) {
				if ($scope.data.params.year !== undefined) {
					$scope.searchQuery.yearBuilt = $scope.data.params.year;
				}

				if ($scope.data.params.type !== undefined) {
					$scope.searchQuery.houseType = $scope.data.params.type;
				}

				if ($scope.data.params.m2 !== undefined) {
					$scope.searchQuery.floorArea = $scope.data.params.m2;
				}

				if ($scope.data.params.room !== undefined) {
					$scope.searchQuery.rooms = $scope.data.params.room;
				}

				// Set proper value for area search
				var initSearchArea = [];
				if ($scope.data.postalCode !== undefined && $scope.data.postalCode.length >= 1) {
					initSearchArea.push($scope.data.postalCode);
				}
				if ($scope.data.county !== undefined && $scope.data.county.length >= 1) {
					initSearchArea.push($scope.data.county);
				}

				$scope.searchQuery.areaSelect = initSearchArea.length ? initSearchArea.join(', ') : '';

				$scope.selectionsMade = true;
			}

			var graphData = [];
			var priceData = [];
			var salesData = [];
			var categories = [];

			// County data
			if ($scope.data.ashiCounty !== undefined && $scope.data.ashiCounty.length >= 1) {
				graphData = $scope.data.ashiCounty;
			}
			// Area data, preferred if available
			if ($scope.data.ashi !== undefined && $scope.data.ashi.length >= 1) {
				graphData = $scope.data.ashi;
			}

			// Process data for graph
			$scope.data.figureEmpty = true;
			for (var i in graphData) {
				if (!graphData.hasOwnProperty(i)) {
					continue;
				}
				priceData.push(graphData[i].priceperm2);
				salesData.push(graphData[i].sales);
				categories.push(graphData[i].year);
				if (graphData[i].priceperm2 && graphData[i].sales && graphData[i].year) {
					$scope.data.figureEmpty = false;
				}
			}

			if (type == 'initial') {
				$timeout(function () {
					if (/asuntojen-hinnat\/?$/.test($location.$$absUrl)) {
						$scope.selectionsMade = false;
					}
				}, 250);
			}

			if (priceData.length === 0 || salesData.length === 0 || categories.length === 0) {
				// No data to draw
				$scope.showPriceGraph = false;
				// @todo - Something else to show when no data! This just shows empty graph.
				//return;
			}
			$scope.showPriceGraph = true;

			// Draw it
			$scope.pricegraph = new Highcharts.Chart({
				chart: {
					zoomType: 'xy',
					renderTo: 'pricegraph',
					backgroundColor: '#ffffff',
					spacingTop: 30,
					spacingLeft: 30,
					spacingRight: 30
				},
				exporting: {
					enabled: false
				},
				credits: {
					enabled: false
				},
				title: {
					margin: 60,
					text: $scope.priceGraphTitle,
					style: {
						color: '#303030',
						fontSize: '16px',
						fontFamily: 'Dax',
						fontWeight: 500
					},
				},
				subtitle: {
					text: ''
				},
				xAxis: [{
					categories: categories,
					crosshair: false,
					tickColor: '#ECECEC',
					tickLength: 0,
					lineColor: '#ECECEC'
				}],
				yAxis: [{ // Primary yAxis
					gridLineColor: '#f6f6f6',
					labels: {
						format: '{value:,.0f}',
						style: {
							color: '#5c5c5c',
							fontSize: '12px'
						},
					},
					title: {
						align: 'high',
						rotation: 0,
						offset: 0,
						style: {
							color: '#5c5c5c'
						},
						text: '€/m²',
						y: -50,
						x: -10
					}
				}, { // Secondary yAxis,
					gridLineColor: '#f6f6f6',
					title: {
						align: 'high',
						rotation: 0,
						offset: 0,
						style: {
							color: '#5c5c5c'
						},
						text: 'kpl',
						y: -50,
						x: 15
					},
					labels: {
						format: '{value:,.0f}',
						style: {
							color: '#5c5c5c',
							fontSize: '12px'
						}
					},
					opposite: true
				}],
				tooltip: {
					shared: true
				},
				legend: {
					align: 'left',
					backgroundColor: '#ffffff',
					floating: false,
					enabled: true,
					itemDistance: 50,
					itemStyle: {
						color: '#797979',
						fontWeight: 'normal',
						marginBottom: '5px'
					},
					layout: 'horizontal',
					margin: 30,
					symbolRadius: 0,
					symbolWidth: 20,
					// symbolHeight: 20,
					symbolPadding: 10,
					// squareSymbol: false,
					verticalAlign: 'bottom',
					x: 40,
				},
				plotOptions: {
					series: {
						states: {
							hover: {
								enabled: false
							}
						}
					},
					arearange: {
						states: {
							hover: {
								enabled: false
							}
						}
					}
				},
				series: [{
					name: 'Kauppoja',
					type: 'column',
					yAxis: 1,
					data: salesData,
					tooltip: {
						valueSuffix: ' kpl'
					},
					color: '#BED7D2',
					borderWidth: 0,
					legendIndex: 1,
					maxPointWidth: 20
				}, {
					animation: true,
					color: '#006450',
					data: priceData,
					legendIndex: 0,
					linecap: 'square',
					marker: {
						fillColor: '#FFFFFF',
						lineColor: '#006450',
						lineWidth: 2
					},
					name: 'Keskineliöhinta',
					tooltip: {
						valueSuffix: ' €/m²'
					},
					type: 'line',
				}]
			});
			// Update prevUrl
			$scope.prevUrl = $scope.getUrlParams();
			// Init done
			$scope.initialized = true;
		};

		$scope.getUrlParams = function(withLocation)
		{
			// Do not trust watch to be fast enough
			$scope.updateUrl();
			var url = angular.copy($scope.url);
			/* Split location to id */
			var id = url['location'].split('/');
			if (id[1] != '0') {
				url.id = id[1];
			} else {
				url.id = id[0];
			}
			if (!withLocation) {
				delete url.location;
			}
			return url;
		};

		$scope.openUrl = function() {
			var url = $scope.getUrlParams(true);
			$window.location = '/asuntojen-hinnat/' + url.location + '/' +  url.type + '/' +  url.room + '/' +  url.year + '/' +  url.m2;
		};

		$scope.updateData = function()
		{
			/* Old IE, Old Style */
			if ($rootScope.useWindowLocation)
			{
				$scope.openUrl();
				return;
			}
			var url = $scope.getUrlParams();
			/* Check has it changed? */
			if (JSON.stringify($scope.prevUrl) == JSON.stringify(url))
			{
				return true;
			}
			/* Request new data */
			$scope.loading = true;
			$scope.agentsLoading = true;
			$scope.housesLoading = true;

			$http({
				method: 'GET',
				url: '/api/km/KMSite/priceCalculator',
				params: url
			}).then(function(response, status, headers, config) {
				$scope.loading = false;
				/* Init and update data */
				$scope.data = response.data.data;
				$scope.init('update');
				/* Update location */
				$window.document.title = 'Asuntojen hinnat '+response.data.data.name+' - Kiinteistömaailma';
				$location.url(response.data.data.params.url);
				_fetchAdditionalData();
				/* Track page view */
				if (typeof _gaq != "undefined") {
					_gaq.push(['_trackPageview', response.data.data.params.url]);
				}
			}, function(data, status, headers, config) {
				console.log("error getting data:", data);
			});
		};

		function _fetchAdditionalData() {

			var url = $scope.getUrlParams();

			/* Request new agents */
			var agentParams = {
				limit: 4,
				key: url['id'],
				apartmentAmount: url['room'],
				apartmentType: url['type']
			};

			$http({
				method: 'GET',
				url: '/api/km/KMSite/agentSearchBySales',
				params: agentParams
			}).then(function (response) {
				$scope.agents = response.data.data['agents'];
				$scope.init('update');
				$scope.agentsLoading = false;
			}, function (error) {
				console.log("error getting agents:", error);
			});

			var propertyParams = {
				roomAmount: url['room'],
				sortArea: url['m2'],
				salesPriceUnencumbered: $scope.data.figureData.priceperm2 * url['m2'],
				limit: 4
			};

			if ( !isNaN(url['id']) ) {
				propertyParams['postcode'] = url['id'];
			} else {
				propertyParams['municipality'] = url['id'];
			}

			$http({
				method: 'GET',
				url: '/api/km/KMSite/propertiesSimilar',
				params: propertyParams
			}).then(function (response) {

				$scope.housesLoading = false;
				console.log($scope.houses);
				$scope.init('update');

				$timeout(function () {
					$scope.houses = response.data.data;
				});

			}, function (error) {
				console.log("error getting agents:", error);
			});
		}

		$scope.getHouseImage = function (house) {
			if (house.images && house.images.length) {
				var imageObj = house.images.filter(function (image) {
					return image.type === 'MAIN';
				});

				if (imageObj[0] && imageObj[0].path && imageObj[0].name) {
					return '/assets/' + imageObj[0].path + '/' + imageObj[0].name;
				} else {
					return '/assets/images/list/noimage-tiny.png';
				}
			} else {
				return '/assets/images/list/noimage-tiny.png';
			}
		};
	}]
);
